//
// Device util
// -----------

define(function(require, exports, module) {
    'use strict';

    var deviceCommon = require('util/device.common.util');
    var devicePlatform = require('util/device.platform.util');

    var deviceUtil = {};
    var extend = function(moduleObj) {
        Object.keys(moduleObj).forEach(function(propName) {
            var descriptor = Object.getOwnPropertyDescriptor(moduleObj, propName);
            Object.defineProperty(deviceUtil, propName, descriptor);
        });
    };
    extend(deviceCommon);
    extend(devicePlatform);

    module.exports = deviceUtil;
});
